export type LibraryOrigin = 'uploaded' | 'community';

export function classifyLibraryOrigin(
  library: { source_library_id?: string | null },
): LibraryOrigin {
  return library.source_library_id != null ? 'community' : 'uploaded';
}
